import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import "./style.sass";
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { ClasicSelectTypeNew } from 'components/Forms/Select';
import { HeaderMobileSolicitud } from 'components/Credito/HeaderPasosMobile';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { useStorage64 } from 'hooks/useStorageBase64';
import { decodeStorage } from 'functions/storageBase64';
import getShipping from 'services/getShipping';
import { titulos, meses, dias, tipoVi, estadosAbreviacion } from 'constants/variables';
import { ModalError } from 'components/Error/ErrorModal';

export function InformacionPersonalMobile({ nextPage, cancelar }) {

    const [shipping, setShupping] = useState({});
    const infoPersonalMobileStorage = decodeStorage("infoPersonalMobileStorage");
    const [datosUsuario, setDatosUsuario] = useState(infoPersonalMobileStorage);

    const [inputNombre, setInputNombre] = useState();
    const [inputApellidoP, setInputApellidoP] = useState();
    const [inputApellidoM, setInputApellidoM] = useState();
    const [inputCorreo, setInputCorreo] = useState();
    const [inputTelefono, setInputTelefono] = useState();

    const [inputCalle, setInputCalle] = useState();
    const [inputRfc, setInputRfc] = useState();
    const [inputNumDependientes, setInputNumDependientes] = useState();
    const [inputCP, setInputCP] = useState(datosUsuario?.CP);

    const [estado, setEstado] = useState();
    const [municipio, setMunicipio] = useState();
    const [ciudad, setCiudad] = useState();
    const [entreCalles, setEntreCalles] = useState();
    const [colonia, setColonia] = useState();

    const [inputHipoteca, setInputHipoteca] = useState();
    const [inputAnioResidencia, setInputAnioResidencia] = useState();
    const [inputMesesResidencia, setInputMesesResidencia] = useState();

    const [returnForm, SetReturnForm] = useState(false);
    const [, setInfoPersonalMobileStorage] = useStorage64('infoPersonalMobileStorage', '');
    const [viviendaR, setViviendaR] = useState(false);

    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);


    const [datos, setDatos] = useState();
    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            titulo: datosUsuario.titulo,
            nombre: datosUsuario.Nombre,
            apellidoP: datosUsuario.APaterno,
            apellidoM: datosUsuario.AMaterno,
            correo: datosUsuario.Email,
            telefono: datosUsuario.Telefono,
            sexo: datosUsuario.Genero,
            dia: datosUsuario?.FechaNacimiento?.substr(6, 2),
            mes: datosUsuario?.FechaNacimiento?.substr(4, 2),
            anio: datosUsuario?.FechaNacimiento?.substr(0, 4),
            rfc: datosUsuario.RFC,
            calle: datosUsuario.Domicilio,
            cp: datosUsuario.CP,
            ciudad: datosUsuario.ciudad,
            estado: datosUsuario.estado,
            colonia: datosUsuario.estado,
            municipio: datosUsuario.municipio,
            numDependientes: datosUsuario.Nodependientes,
            entreCalles: datosUsuario.EntreCalle,
            tipoVivienda: datosUsuario.TipoVivienda,
            hipoteca: datosUsuario.MontoRenta,
            anioResidencia: datosUsuario.TiempoResAnio,
            mesesResidencia: datosUsuario.TiempoResMes
        }
    });

    // guarda la informacion enviada en el formulario
    const sendFormInformacionUsuario = data => {
        let resultado = [];
        estadosAbreviacion.map((ele) =>
            ele.completo === String(data.estado).toLowerCase()
                ? resultado.push(ele.inicial)
                : null//resultado.push(data.estado)
        )

        setDatos({
            "Comp": "076",
            "Tienda": "00576",
            // "Titulo": data.titulo,
            "Nombre": data.nombre,
            "APaterno": data.apellidoP,
            "AMaterno": data.apellidoM,
            "Email": data.correo,
            "Telefono": data.telefono,
            "Celular": data.telefono,
            "Genero": data.sexo,
            "FechaNacimiento": data.anio + data.mes + data.dia,
            "RFC": data.rfc,
            "Nodependientes": Number(data.numDependientes),
            "Domicilio": data.calle, //+ "," + data.numExt + " " + data.numInt,
            "CP": data.cp,
            // "Estado": data.estado,
            "Municipio": data.municipio,
            "Estado": resultado[0],//data.estado,
            "Colonia": data.colonia,
            "Ciudad": data.ciudad,
            "EntreCalle": data.entreCalles,
            "TipoVivienda": data.tipoVivienda,
            "MontoRenta": Number(data.hipoteca),
            "TiempoResAnio": Number(data.anioResidencia),
            "TiempoResMes": Number(data.mesesResidencia)
        })
        SetReturnForm(true);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    // al recibir data del formulario se guarda en variable datos del usuario
    useEffect(() => {
        if (returnForm) {
            setDatosUsuario(datos);
            SetReturnForm(false);
            setInfoPersonalMobileStorage(datos); //guarda en storage informacion personal
            nextPage(2);
        }
    }, [returnForm])

    // funcion que calcula el array de años desde la fecha actual con un rango de 100 años
    function rangeYear() {
        const max = new Date().getFullYear() - 15;
        const min = max - 100;
        const years = [];

        for (let i = max; i >= min; i--) {
            years.push({ "id": i, "value": i });
        }
        return years;
    }

    const [genero, setGenero] = useState(false);
    const seleccionarGenero = (e) => {
        setGenero(e.target.value);
    }

    // validaciones de campos
    const valTitulo = {
        required: 'Campo obligatorio'
    }
    const valNombre = {
        required: 'Campo obligatorio',
        minLength: {
            value: 3,
            message: 'El nombre al menos debe de contener 3 carácteres'
        },
        maxLength: {
            value: 20,
            message: 'El nombre debe contener un máximo de 20 carácteres'
        }
    }
    const valApellidoP = {
        required: 'Campo obligatorio',
        maxLength: {
            value: 20,
            message: 'El apellido paterno debe contener un máximo de 20 carácteres'
        }
    }
    const valApellidoM = {
        // required: 'Campo obligatorio',
        maxLength: {
            value: 20,
            message: 'El apellido materno debe contener un máximo de 20 carácteres'
        }
    }
    const valCorreo = {
        required: 'El Correo electrónico es requerido',
        pattern: {
            value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'El formato de correo electrónico es inválido'
        },
        maxLength: {
            value: 250,
            message: 'El correo electrónico debe contener máximo 250 dígitos'
        }
    }
    const valTelefono = {
        required: 'Campo obligatorio',
        minLength: {
            value: 10,
            message: 'Faltan dígitos. Deben ser 10 dígitos'
        },
        maxLength: {
            value: 10,
            message: 'No debe contener más de 10 dígitos'
        }
    }
    const valDia = {
        required: 'Campo obligatorio'
    }
    const valMes = {
        required: 'Campo obligatorio'
    }
    const valAnio = {
        required: 'Campo obligatorio'
    }
    const valSexo = {
        required: 'Campo obligatorio',
    };

    const valNumDependientes = {
        required: 'Campo obligatorio'
    }
    const valRfc = {
        required: 'Campo obligatorio',
        maxLength: {
            value: 10,
            message: 'No debe contener más de 10 dígitos'
        }
    }
    const valCalle = {
        required: 'Campo obligatorio',
        maxLength: {
            value: 30,
            message: 'No debe contener más de 30 dígitos'
        }
    };
    const valNumExt = {
        required: 'Campo obligatorio',
    };
    const valNumInt = {
    };
    const valEntreCalles = {
    };
    const valCp = {
        required: 'Campo obligatorio',
        minLength: {
            value: 5,
            message: 'Faltan dígitos. Deben ser 5 dígitos'
        },
        maxLength: {
            value: 5,
            message: 'No debe contener más de 5 dígitos'
        },
        pattern: {
            value: /[0-9]{0,99999}/,
            message: 'El formato de CP es inválido'
        }
    };
    const valEstado = {
        required: 'Campo obligatorio',
    };
    const valMunicipio = {
        required: 'Campo obligatorio',
    };
    const valCiudad = {
        required: 'Campo obligatorio',
    };
    const valColonia = {
        required: 'La Colonia es requerida',
        minLength: {
            value: 1,
            message: 'El estado es requerido'
        },
        maxLength: {
            value: 120,
            message: 'La colonia debe tener un máximo de 120 caracteres'
        }
    };
    const valHipoteca = {
        required: viviendaR
    }
    const valAnioRes = {
        required: 'Campo obligatorio'
    }
    const valMesRes = {
        required: 'Campo obligatorio',
        max: {
            value: 11,
            message: 'La cantidad máxima de meses que puede tener este campo son 11'
        }
    }
    const valTipoVivienda = {
        required: 'Campo obligatorio'
    }

    // llenado de campos con cp
    useEffect(() => {
        if (inputCP) {
            if (inputCP.length === 5) {
                getShipping({ codigoPostal: inputCP })
                    .then(setShupping)
            }
            else if (inputCP.length < 5 || inputCP.length === 0) {
                setEstado('');
                setMunicipio('');
                setCiudad('');
                setColonia([]);
            }
        }
    }, [inputCP])

    useEffect(() => {
        if (shipping) {
            setEstado(shipping.estado);
            setMunicipio(shipping.municipio);
            setCiudad(shipping.ciudad);

            if (shipping?.code === 200) {
                clearErrors('estado');
                clearErrors("ciudad");
                clearErrors("colonia");
                clearErrors("municipio");
            }

            if (shipping.colonias) {
                if (shipping.colonias.length === 0) {
                    setColonia([]);
                }
                else if (shipping.colonias.length >= 1) {
                    setColonia(shipping.colonias);
                }
            }

            if (shipping?.code === 404) {
                setShowModalErr(true);
                setErrorCode(shipping?.code);
                setSectionActive('cp');
                setMessageResponse(shipping?.error);
            }
        }
    }, [shipping])

    const resetErrors = (value) => {
        let inputId = document.querySelector(`#${value} ~ .error`)
        if (inputId) {
            let valu = value
            clearErrors(valu)
            reset({ valu }, {
                keepErrors: false,
                keepDirty: true,
                keepIsSubmitted: false,
                keepTouched: false,
                keepIsValid: false,
                keepSubmitCount: false,
            });
        }
    }

    useEffect(() => {
        if (!inputCP) {
            setEstado('');
            setMunicipio('');
            setCiudad('');
            setColonia([]);

            // reset({
            //     keepErrors: false,
            //     keepDirty: false,
            //     keepIsSubmitted: false,
            //     keepTouched: false,
            //     keepIsValid: false,
            //     keepSubmitCount: false,
            // });
            document.getElementById("colonia").value = "";
            document.getElementById("estado").value = "";
            document.getElementById("ciudad").value = "";
            document.getElementById("municipio").value = "";
        }
    }, [inputCP])

    const validaDia = () => {
        let mesSelect = document.querySelector("#mes")?.value
        let anioSelect = document.querySelector("#anio")?.value

        if (mesSelect === "02") {
            if (Number(anioSelect) % 400 === 0 || Number(anioSelect) % 4 === 0) {
                if (Number(document.querySelector("#dia")?.value) >= Number(30)) {
                    document.querySelectorAll(`#dia option`)[29].selected = true
                }
            } else {
                if (Number(document.querySelector("#dia")?.value) >= Number(29)) {
                    document.querySelectorAll(`#dia option`)[28].selected = true
                }
            }
        }
        else if (mesSelect === "04" || mesSelect === "06" || mesSelect === "09" || mesSelect === "11") {
            if (Number(document.querySelector("#dia")?.value) === Number(31)) {
                document.querySelectorAll(`#dia option`)[30].selected = true
            }
        }

        if (document.querySelector('#tipoVivienda').value === "R" || document.querySelector('#tipoVivienda').value === 'X') {
            setViviendaR('Campo obligatorio')
        } else if (document.querySelector('#tipoVivienda').value === "O" || document.querySelector('#tipoVivienda').value === 'P') {
            resetErrors('tipoVivienda')
            setViviendaR(false)
        }

    }

    // realiza accion al cerrar modal error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (String(sectionActive) === 'cp') {
            setInputCP();
            document.getElementById("cp").value = "";
        }
    }

    return (
        <>
            <div className="modalCredito full">
                <div className="contentModal">
                    <HeaderMobileCredito title="Solicitud de Crédito Claroshop" type="back" />

                    <div className="contenedorGeneral top0">
                        <div className="boxSolicitud">

                            <HeaderMobileSolicitud titulo={"INFORMACIÓN PERSONAL"} posicion={1} totalItems={3} />

                            <form onSubmit={handleSubmit(sendFormInformacionUsuario)} className="formularioSolicitudMobile" onChange={validaDia}>
                                <div className="tituloFormulariosMobile">
                                    <p>Verifica tu información</p>
                                </div>

                                <div className="divFormMobile">

                                    <ClasicSelectTypeNew
                                        type="text"
                                        name="titulo"
                                        id="titulo"
                                        placeholder="Título"
                                        className="desktopInput"
                                        refs={register(valTitulo)}
                                        options={titulos}
                                        errorMessage={errors.titulo && errors.titulo.message}
                                    />
                                </div>

                                <div className="divFormMobile">
                                    <InputTypeAndroid
                                        type="text"
                                        name="nombre"
                                        id="nombre"
                                        placeholder="Nombre"
                                        refs={register(valNombre)}
                                        className="desktopInput"
                                        autocomplete='name'
                                        setNumero={setInputNombre}
                                        // value={inputNombre}
                                        numero={inputNombre}
                                        errorMessage={errors.nombre && errors.nombre.message}
                                        pattern={'textOnly'}
                                        maxLength={20}
                                    />
                                </div>

                                <div className="divFormMobile">
                                    <InputTypeAndroid
                                        type="text"
                                        name="apellidoP"
                                        id="apellidoP"
                                        placeholder="Apellido Paterno"
                                        refs={register(valApellidoP)}
                                        className="desktopInput"
                                        setNumero={setInputApellidoP}
                                        // value={inputApellidoP}
                                        numero={inputApellidoP}
                                        errorMessage={errors.apellidoP && errors.apellidoP.message}
                                        pattern={'textOnly'}
                                        maxLength={20}
                                    />
                                </div>

                                <div className="divFormMobile">
                                    <InputTypeAndroid
                                        type="text"
                                        name="apellidoM"
                                        id="apellidoM"
                                        placeholder="Apellido Materno"
                                        refs={register(valApellidoM)}
                                        className="desktopInput"
                                        setNumero={setInputApellidoM}
                                        value={inputApellidoM}
                                        errorMessage={errors.apellidoM && errors.apellidoM.message}
                                        pattern={'textOnly'}
                                        maxLength={20}
                                    />
                                </div>

                                <div className="divFormMobile">
                                    <InputTypeAndroid
                                        type="text"
                                        name="correo"
                                        id="correo"
                                        placeholder="Correo electrónico"
                                        refs={register(valCorreo)}
                                        className="desktopInput"
                                        autocomplete='email'
                                        setNumero={setInputCorreo}
                                        // value={inputCorreo}
                                        numero={inputCorreo}
                                        errorMessage={errors.correo && errors.correo.message}
                                        pattern={'textOnly'}
                                        maxLength={250}
                                    />
                                </div>

                                <div className="divFormMobile">
                                    <InputTypeAndroid
                                        type="text"
                                        name="telefono"
                                        id="telefono"
                                        placeholder="Celular a 10 dígitos"
                                        refs={register(valTelefono)}
                                        className="desktopInput"
                                        autocomplete='tel'
                                        setNumero={setInputTelefono}
                                        // value={inputTelefono}
                                        numero={inputTelefono}
                                        errorMessage={errors.telefono && errors.telefono.message}
                                        pattern={'number'}
                                        maxLength={10}
                                    />
                                </div>

                                <div className="divFormMobile">
                                    <div className="boxGeneroM">
                                        <p>Sexo:</p>

                                        <ul className={genero === false && errors.sexo && errors.sexo.message ? "ulGeneroMobile conError" : "ulGeneroMobile"} onChange={seleccionarGenero}>
                                            <li id="masculino">
                                                <input className="radio" id="m" type="radio" value="M" name="sexo"
                                                    checked={genero === "M" ? true : false} ref={register(valSexo)}
                                                />
                                                <label name="m" htmlFor="m"> Masculino </label>
                                            </li>
                                            <li id="femenino">
                                                <input className="radio" id="f" type="radio" value="F" name="sexo"
                                                    checked={genero === "F" ? true : false} ref={register(valSexo)}
                                                />
                                                <label name="f" htmlFor="f"> Femenino </label>
                                            </li>
                                        </ul>

                                        {genero === false && errors.sexo && errors.sexo.message
                                            ? <div className="error">Campo obligatorio</div>
                                            : null
                                        }
                                    </div>
                                </div>

                                <div className="divFormMobile">
                                    <div className="subCampo">
                                        <div className="triple">
                                            <div className="diaAnio">
                                                <ClasicSelectTypeNew
                                                    type="text"
                                                    name="dia"
                                                    id="dia"
                                                    placeholder="Día"
                                                    className="desktopInput"
                                                    refs={register(valDia)}
                                                    options={dias}
                                                    errorMessage={errors.dia && errors.dia.message}
                                                />
                                            </div>
                                            <div className="diaAnio">
                                                <ClasicSelectTypeNew
                                                    type="text"
                                                    name="mes"
                                                    id="mes"
                                                    placeholder="Mes"
                                                    className="desktopInput"
                                                    refs={register(valMes)}
                                                    options={meses}
                                                    errorMessage={errors.mes && errors.mes.message}
                                                />
                                            </div>
                                            <div className="diaAnio">
                                                <ClasicSelectTypeNew
                                                    type="text"
                                                    name="anio"
                                                    id="anio"
                                                    placeholder="Año"
                                                    className="desktopInput"
                                                    refs={register(valAnio)}
                                                    options={rangeYear()}
                                                    errorMessage={errors.anio && errors.anio.message}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="divFormMobile">
                                    <InputTypeAndroid
                                        type="text"
                                        id="rfc"
                                        name="rfc"
                                        placeholder="RFC"
                                        className="desktopInput"
                                        errorMessage={errors.rfc && errors.rfc.message}
                                        refs={register(valRfc)}
                                        minLength={10}
                                        maxLength={13}
                                        setNumero={setInputRfc}
                                        // value={inputRfc}
                                        numero={inputRfc}
                                        pattern={'textOnly'}
                                    // click={() => resetErrors('rfc')}
                                    />
                                </div>

                                <div className="divFormMobile">
                                    <InputTypeAndroid
                                        type="text"
                                        id="numDependientes"
                                        name="numDependientes"
                                        autocomplete="numDependientes"
                                        placeholder="No. de dependientes"
                                        className="desktopInput"
                                        errorMessage={errors.numDependientes && errors.numDependientes.message}
                                        refs={register(valNumDependientes)}
                                        setNumero={setInputNumDependientes}
                                        value={inputNumDependientes}
                                        pattern={'number'}
                                        maxLength={2}
                                    />
                                </div>


                                <>
                                    <p className="subtitulosMobile">Vivienda</p>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="calle"
                                            name="calle"
                                            placeholder="Calle y número"
                                            className="desktopInput"
                                            errorMessage={errors.calle && errors.calle.message}
                                            refs={register(valCalle)}
                                            pattern={'textOnly'}
                                            setNumero={setInputCalle}
                                            // value={inputCalle}
                                            numero={inputCalle}
                                            maxLength={30}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="cp"
                                            name="cp"
                                            placeholder="Código Postal"
                                            className="desktopInput"
                                            errorMessage={errors.cp && errors.cp.message}
                                            refs={register(valCp)}
                                            pattern={'number'}
                                            maxLength={5}
                                            setNumero={setInputCP}
                                            // value={inputCP}
                                            numero={inputCP}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        {colonia && colonia.length >= 2
                                            ?
                                            <ClasicSelectTypeNew
                                                type="text"
                                                name="colonia"
                                                id="colonia"
                                                placeholder="Colonia"
                                                className="desktopInput"
                                                refs={register(valColonia)}
                                                options={colonia}
                                                errorMessage={errors.colonia && errors.colonia.message}
                                                click={() => resetErrors('colonia')}
                                            />
                                            :
                                            <InputTypeAndroid
                                                type="text"
                                                name="colonia"
                                                id="colonia"
                                                placeholder="Colonia"
                                                refs={register(valColonia)}
                                                value={colonia}
                                                readonly="readonly"
                                                className="desktopInput"
                                                errorMessage={errors.colonia && errors.colonia.message}
                                                click={() => resetErrors('colonia')}
                                            />
                                        }
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="municipio"
                                            name="municipio"
                                            placeholder="Municipio"
                                            className="desktopInput"
                                            errorMessage={errors.municipio && errors.municipio.message}
                                            refs={register(valMunicipio)}
                                            value={municipio}
                                            readonly="readonly"
                                            click={() => resetErrors('municipio')}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="estado"
                                            name="estado"
                                            placeholder="Estado"
                                            className="desktopInput"
                                            errorMessage={errors.estado && errors.estado.message}
                                            refs={register(valEstado)}
                                            readonly="readonly"
                                            value={estado}
                                            click={() => resetErrors('estado')}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="ciudad"
                                            name="ciudad"
                                            placeholder="Ciudad"
                                            className="desktopInput"
                                            errorMessage={errors.ciudad && errors.ciudad.message}
                                            refs={register(valCiudad)}
                                            readonly="readonly"
                                            value={ciudad}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="entreCalles"
                                            name="entreCalles"
                                            placeholder="Entre calles (opcional)"
                                            className="desktopInput"
                                            errorMessage={errors.entreCalles && errors.entreCalles.message}
                                            refs={register(valEntreCalles)}
                                            setNumero={setEntreCalles}
                                            value={entreCalles}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <ClasicSelectTypeNew
                                            type="text"
                                            name="tipoVivienda"
                                            id="tipoVivienda"
                                            placeholder="Tipo de vivienda"
                                            className="desktopInput"
                                            refs={register(valTipoVivienda)}
                                            options={tipoVi}
                                            errorMessage={errors.tipoVivienda && errors.tipoVivienda.message}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            name="hipoteca"
                                            id="hipoteca"
                                            placeholder="Hipoteca / Renta"
                                            refs={register(valHipoteca)}
                                            className="desktopInput"
                                            autocomplete='hipoteca'
                                            setNumero={setInputHipoteca}
                                            value={inputHipoteca}
                                            errorMessage={viviendaR ? errors.hipoteca && errors.hipoteca.message : null}
                                            pattern={'number'}
                                            maxLength={10}
                                        // click={() => resetErrors('hipoteca')}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <div className="subCampo">
                                            <p>Tiempo de residir en esta dirección</p>
                                            <div className="doble">
                                                <div className="diaAnio">
                                                    <InputTypeAndroid
                                                        type="text"
                                                        name="anioResidencia"
                                                        id="anioResidencia"
                                                        placeholder="Años"
                                                        refs={register(valAnioRes)}
                                                        className="desktopInput labelRight"
                                                        autocomplete='anioResidencia'
                                                        setNumero={setInputAnioResidencia}
                                                        numero={inputAnioResidencia}
                                                        // value={inputAnioResidencia}
                                                        errorMessage={errors.anioResidencia && errors.anioResidencia.message}
                                                        pattern={'number'}
                                                        maxLength={2}
                                                    // click={() => resetErrors('anioResidencia')}
                                                    />
                                                </div>
                                                <div className="diaAnio">
                                                    <InputTypeAndroid
                                                        type="text"
                                                        name="mesesResidencia"
                                                        id="mesesResidencia"
                                                        placeholder="Meses"
                                                        refs={register(valMesRes)}
                                                        className="desktopInput labelRight"
                                                        autocomplete='mesesResidencia'
                                                        setNumero={setInputMesesResidencia}
                                                        // value={inputMesesResidencia}
                                                        numero={inputMesesResidencia}
                                                        errorMessage={errors.mesesResidencia && errors.mesesResidencia.message}
                                                        pattern={'number'}
                                                        maxLength={2}
                                                        max={11}
                                                    // click={() => resetErrors('mesesResidencia')}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>

                                <div className="boxBotonesMobile">
                                    <button className="btnRedM">Siguiente</button>
                                    <button className="btnWhiteM" onClick={cancelar}>Cancelar</button>
                                </div>
                            </form>

                            {showModalErr &&
                                <ModalError
                                    errorCode={errorCode}
                                    section={sectionActive}
                                    message={messageResponse}
                                    handleClose={handleCloseErr}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}